var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Link as RouterLink, useRouteMatch } from "react-router-dom";
import { BorderAll, CloudUpload, ExitToApp, Headset, Person, Assignment, } from "@material-ui/icons";
import { Box, Link, List, ListItem, ListItemIcon, ListItemText, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { paths } from "frontend/src/pages/paths/index";
import { logout } from "frontend/src/features/session";
import { useClient } from "frontend/src/domain/client";
import { useViewer } from "frontend/src/domain/session";
var path = paths.business.owner;
var useStyles = makeStyles(function (theme) { return ({
    nested: {
        paddingLeft: function (_a) {
            var level = _a.level;
            return theme.spacing(level * 2);
        },
    },
    list: {
        padding: theme.spacing(1),
    },
    item: {
        borderRadius: 6,
        marginBottom: 2,
        minHeight: 42,
        color: "rgba(255, 255, 255, 0.88)",
        "& .MuiListItemIcon-root": {
            color: "rgba(255, 255, 255, 0.82)",
        },
        "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
        },
        "&.Mui-selected": {
            color: "#fff",
            backgroundColor: "rgba(255, 255, 255, 0.14)",
            borderLeft: "3px solid rgba(255, 255, 255, 0.82)",
            "& .MuiListItemIcon-root": {
                color: "#fff",
            },
        },
    },
    icon: {
        minWidth: 38,
    },
    support: {
        padding: theme.spacing(2, 2, 1),
        color: "rgba(255, 255, 255, 0.72)",
    },
    supportLink: {
        display: "block",
        color: "inherit",
        textDecoration: "none",
        overflowWrap: "anywhere",
        "&:hover": {
            color: "#fff",
            textDecoration: "underline",
        },
    },
}); });
var Nav = function (_a) {
    var name = _a.name, url = _a.url, icon = _a.icon, level = _a.level;
    var classes = useStyles({ level: level });
    var match = useRouteMatch(url);
    return (React.createElement(ListItem, { button: true, selected: Boolean(match), component: RouterLink, to: url, className: classes.nested + " " + classes.item },
        React.createElement(ListItemIcon, { className: classes.icon }, icon),
        React.createElement(ListItemText, { primary: name })));
};
export var Navigation = function () {
    var _a, _b;
    var onExit = function () { return logout(); };
    var classes = useStyles({ level: 1 });
    var user = useViewer().user;
    var client = useClient(user === null || user === void 0 ? void 0 : user.clientId);
    var nav = [
        {
            name: "Мои плейлисты",
            url: path.playlists.index("private"),
            icon: React.createElement(Person, null),
        },
        {
            name: "Плейлисты imstream",
            url: path.playlists.index("public"),
            icon: React.createElement(Headset, null),
        },
        {
            name: "Расписание плейлистов",
            url: path.schedules.index(),
            icon: React.createElement(BorderAll, null),
        },
        {
            name: "Загруженные файлы",
            icon: React.createElement(CloudUpload, null),
            url: path.files.index(),
        },
    ];
    if ((_a = client.data) === null || _a === void 0 ? void 0 : _a.showTimetables) {
        nav.push({
            name: "Сетки вещания",
            url: path.timetables.index(),
            icon: React.createElement(BorderAll, null),
        });
    }
    if ((_b = client.data) === null || _b === void 0 ? void 0 : _b.showDetails) {
        nav.push({
            name: "Мои данные",
            icon: React.createElement(Assignment, null),
            url: path.details.index(),
        });
    }
    return (React.createElement(List, { className: classes.list },
        nav.map(function (props) { return (React.createElement(Nav, __assign({ key: props.name }, props, { level: 1 }))); }),
        React.createElement(ListItem, { button: true, onClick: onExit, className: classes.item },
            React.createElement(ListItemIcon, { className: classes.icon },
                React.createElement(ExitToApp, null)),
            React.createElement(ListItemText, { primary: "Выход" })),
        React.createElement(Box, { className: classes.support },
            React.createElement(Typography, { variant: "caption", display: "block" }, "\u041F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430:"),
            React.createElement(Link, { className: classes.supportLink, href: "mailto:info@imstream.net" }, "info@imstream.net"),
            React.createElement(Link, { className: classes.supportLink, href: "https://t.me/info_imstream", target: "_blank", rel: "noopener noreferrer" }, "t.me/info_imstream"))));
};
